import React from "react";
import { ORDERS_TYPE_PENDING } from "core/utils/constCapsule";
import { PendingOfferButton } from "features/PendingOfferButton";

export function PendingOfferAction({ ordersType, ...restProps }) {
  if (ordersType !== ORDERS_TYPE_PENDING) return null;
  return <PendingOfferButton ordersType={ordersType} {...restProps} />;
}
